import {STATE_COMPLETED} from '../projects/constants';
import {STATE_OPEN} from '../projects/constants';

const initialState = {
  'byId': new Map(), 
  'totals': {},
  'modalState': 'closed',
  'currentlyEditing': {},
  'lastSaved': {},
};

function gatherChildProjects(category, projects) {
  for (const child of category.children) {
    if (child.type == 'category') {
      gatherChildProjects(child, projects);
    } else {
      projects.push(child);
    }
  }
}

function completeCategory(state, category) {
  const projects = [];
  gatherChildProjects(category, projects);
  for (const project of projects) {
    project.track_project_state_id = STATE_COMPLETED;
    state.totals[project.id].track_project_state_id = STATE_COMPLETED;
    state.byId.set(project.id, project);
  }
  return {...state, byId: new Map([...state.byId]), totals: {...state.totals}};
}

function reopenProject(state, project) {
  project.track_project_state_id = STATE_OPEN;
  state.byId.set(project.id, project);
  state.totals[project.id].track_project_state_id = STATE_OPEN;
  return {...state, byId: new Map([...state.byId]), totals: {...state.totals}};
}

function deleteCategory(state, category) {
  const projects = [];
  for (const child of category.children) {
    if (child.type != 'project') {
      continue;
    }
    child.track_project_category_id = null;
    state.byId.set(child.id, child);
    state.totals[child.id].track_project_category_id = null;
  }
  return {...state, byId: new Map([...state.byId]), totals: {...state.totals}};
}

export function projectsReducer(state = initialState, action) {
  switch (action.type) {
    case 'INSERT_PROJECT':
      state.byId.set(action.payload.id, action.payload);
      return {
        ...state,
        lastSaved: action.payload,
        byId: new Map([...state.byId]),
      };
    case 'UPDATE_PROJECT': {
      const existingProject = state.byId.get(action.payload.id);
      const newProject = Object.assign({}, existingProject, action.payload);
      const totals = state.totals[action.payload.id];
      state.byId.set(action.payload.id, newProject);
      state.totals[action.payload.id] = {...totals, ...newProject};
      return {
        ...state,
        lastSaved: action.payload,
        byId: new Map([...state.byId]),
        totals: {...state.totals},
      };
    }
    case 'DELETE_PROJECT':
      state.byId.delete(action.payload.id);
      return {
        ...state,
        byId: new Map([...state.byId]),
      };
    case 'UPDATE_PROJECTS':
      return {
        ...state,
        byId: new Map([...state.byId, ...action.payload]),
      };
    case 'PROJECTS_LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    case 'UPDATE_PROJECT_TOTALS': {
      let newTotals = {};
      const projectsTotals = Object.entries(action.payload);
      for (let [projectId, projectTotals] of projectsTotals) {
        newTotals[projectId] = Object.assign({}, projectTotals);
      }
      return {
        ...state,
        totals: Object.assign({}, state.totals, action.payload)
      };
    }
    case 'SET_CURRENTLY_EDITING_PROJECT':
      return {
        ...state,
        currentlyEditing: Object.assign({}, action.payload),
      };
    case 'SET_PROJECT_MODAL_STATE':
      return {
        ...state,
        modalState: action.payload,
      };
    case 'DELETE_CATEGORY':
      return deleteCategory(state, action.payload);
    case 'COMPLETE_CATEGORY':
      return completeCategory(state, action.payload);
    case 'REOPEN_PROJECT':
      return reopenProject(state, action.payload);
    default:
      return state;
  }
}
